export enum ErrorLevel {
    IGNORE = 'ignore',
    WARNING = 'warning',
    ERROR = 'error',
    FATAL = 'fatal'
  }
  